export default __webpack_public_path__ + "static/media/czerwone-podkreslenie.4d1e7f16.png";